import axiosInstance from "../../utils/config/config";
import { filterTestPractitioners } from "../../utils/practitioners";

export const getAllPractitioners = () => async (dispatch) => {
  try {
    dispatch({
      type: "practitionersRequest",
    });

    const { data } = await axiosInstance.get("user/staff/calendars");

    dispatch({
      type: "practitionersSuccess",
      payload: filterTestPractitioners(data.staff),
    });
  } catch (error) {
    dispatch({
      type: "practitionersFailure",
      payload: error.response?.data?.message || error.message,
    });
  }
};
